
const TwitterSvg = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M3 3h5.5l4.5 7.5 6-7.5H21l-7.5 9.5L21 21h-5.5l-4.5-7-6 7H3l7.5-9.5L3 3Z"
        fill="#000000"
      />
    </svg>
  );
};

export default TwitterSvg;